module.exports = __webpack_public_path__ + "mainassets/img/form-message.499d9c70.svg";